import { AuthUser } from '#client/index'

export interface AuthUserState {
  isLoggedIn: boolean
  isEmailVerified: boolean
  isProfileRegistered: boolean
  isVerified: boolean
  isCorporateUser: boolean
  isSubscribedUser: boolean
}

export const getAuthUserState = (
  authUser: AuthUser | null | undefined,
): AuthUserState => {
  const isLoggedIn = Boolean(authUser && authUser.email)
  const isEmailVerified = Boolean(authUser && authUser.emailVerifiedAt)
  const isProfileRegistered = Boolean(authUser && authUser.name)
  const isVerified = isLoggedIn && isEmailVerified && isProfileRegistered
  const isCorporateUser = Boolean(authUser && authUser.isCorporateMember)
  const isSubscribedUser =
    (authUser?.pointSubscription?.status === 'active' ||
      authUser?.pointSubscription?.status === 'paused') ??
    false

  return {
    isLoggedIn,
    isEmailVerified,
    isProfileRegistered,
    /**
     * Wether the user is logged in and has completed the registration process
     */
    isVerified,
    isCorporateUser,
    isSubscribedUser,
  }
}
